webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(118);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(117);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vue2Filters = __webpack_require__(119);
	
	var _vue2Filters2 = _interopRequireDefault(_vue2Filters);
	
	var _bootstrapVue = __webpack_require__(60);
	
	var _bootstrapVue2 = _interopRequireDefault(_bootstrapVue);
	
	__webpack_require__(97);
	
	var _fontawesome = __webpack_require__(22);
	
	var _fontawesome2 = _interopRequireDefault(_fontawesome);
	
	var _fontawesomeFreeSolid = __webpack_require__(40);
	
	var _fontawesomeProSolid = __webpack_require__(42);
	
	var _fontawesomeProRegular = __webpack_require__(41);
	
	__webpack_require__(53);
	
	var _App = __webpack_require__(101);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Home = __webpack_require__(102);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Tracker = __webpack_require__(103);
	
	var _Tracker2 = _interopRequireDefault(_Tracker);
	
	var _Roller = __webpack_require__(106);
	
	var _Roller2 = _interopRequireDefault(_Roller);
	
	var _Modifiers = __webpack_require__(104);
	
	var _Modifiers2 = _interopRequireDefault(_Modifiers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_bootstrapVue2.default);
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vue2Filters2.default);
	
	_fontawesome2.default.library.add(_fontawesomeFreeSolid.faExclamationTriangle, _fontawesomeFreeSolid.faRedo, _fontawesomeFreeSolid.faTimes, _fontawesomeFreeSolid.faTint, _fontawesomeFreeSolid.faTrash, _fontawesomeFreeSolid.faSave, _fontawesomeFreeSolid.faCog, _fontawesomeFreeSolid.faSync, _fontawesomeFreeSolid.faClone, _fontawesomeFreeSolid.faCrosshairs, _fontawesomeFreeSolid.faBan, _fontawesomeFreeSolid.faSpinner, _fontawesomeFreeSolid.faBomb, _fontawesomeFreeSolid.faPlus);
	_fontawesome2.default.library.add(_fontawesomeProSolid.faChevronDoubleUp, _fontawesomeProSolid.faPen, _fontawesomeProSolid.faArrowToTop, _fontawesomeProSolid.faArrowToBottom, _fontawesomeProSolid.faLevelDown);
	_fontawesome2.default.library.add(_fontawesomeProRegular.faPlus, _fontawesomeProRegular.faTimes, _fontawesomeProRegular.faArrowRight);
	_fontawesome2.default.dom.i2svg();
	
	var routes = [{ path: '/home', component: _Home2.default, alias: '/' }, { path: '/modifiers', component: _Modifiers2.default }, { path: '/tracker', component: _Tracker2.default }, { path: '/roller', component: _Roller2.default }];
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	  base: ({"NODE_ENV":"production"}).environment === 'development' ? '/' : '/shadowtools/',
	  routes: routes
	});
	
	new _vue2.default({
	  el: '#app',
	  router: router,
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(28);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	exports.default = function (obj) {
	  return JSON.parse((0, _stringify2.default)(obj));
	};
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EdgeMode = undefined;
	
	var _freeze = __webpack_require__(57);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EdgeMode = exports.EdgeMode = (0, _freeze2.default)({
	  NONE: 0,
	  PUSH_LIMIT_PRE: 1,
	  PUSH_LIMIT_POST: 2,
	  SECOND_CHANCE: 3,
	  CLOSE_CALL: 4
	});
	
	exports.default = EdgeMode;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  methods: {
	    calcTotalHits: function calcTotalHits(dice) {
	      var _this = this;
	
	      return dice.reduce(function (hits, group) {
	        return hits + _this.calcGroupHits(group);
	      }, 0);
	    },
	    calcTotalMisses: function calcTotalMisses(dice) {
	      var _this2 = this;
	
	      return dice.reduce(function (misses, group) {
	        return misses + _this2.calcGroupMisses(group);
	      }, 0);
	    },
	    calcGroupHits: function calcGroupHits(group) {
	      return group.reduce(function (hits, value) {
	        return value >= 5 ? hits + 1 : hits;
	      }, 0);
	    },
	    calcGroupMisses: function calcGroupMisses(group) {
	      return group.reduce(function (misses, value) {
	        return value === 1 ? misses + 1 : misses;
	      }, 0);
	    },
	    calcDicePool: function calcDicePool(dice) {
	      return dice.reduce(function (count, group) {
	        return count + group.length;
	      }, 0);
	    },
	    calcSum: function calcSum(dice) {
	      return dice.reduce(function (sum, group) {
	        return group.reduce(function (groupSum, value) {
	          return groupSum + value;
	        }, 0);
	      }, 0);
	    }
	  }
	};

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  methods: {
	    zeroOrLess: function zeroOrLess(value) {
	      return value > 0 ? 0 : value;
	    },
	    zeroOrGreater: function zeroOrGreater(value, test) {
	      return value < 0 ? 0 : value;
	    }
	  }
	};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(28);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _deepCopy = __webpack_require__(14);
	
	var _deepCopy2 = _interopRequireDefault(_deepCopy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var localStorageEnabled = true;
	
	var test = 'test';
	try {
	  localStorage.setItem(test, test);
	  localStorage.removeItem(test);
	} catch (e) {
	  localStorageEnabled = false;
	}
	
	exports.default = {
	  data: function data() {
	    return {
	      dataId: '',
	      localStorageEnabled: false,
	      userData: {}
	    };
	  },
	
	
	  created: function created() {
	    if (this.dataId === '') {
	      throw new Error('Component with storage mixin requires dataId to be set');
	    }
	
	    if (!this.hasOwnProperty('defaultUserData')) {
	      throw new Error('Component with storage mixin requires defaultUserData to be set');
	    }
	
	    this.loadUserData();
	  },
	
	  methods: {
	    loadUserData: function loadUserData() {
	      if (!localStorageEnabled) return;
	
	      var newData = localStorage.getItem(this.dataId);
	      if (newData) this.userData = JSON.parse(newData);else this.userData = (0, _deepCopy2.default)(this.defaultUserData);
	    },
	
	    saveUserData: function saveUserData() {
	      if (!localStorageEnabled) return;
	
	      var stringData = (0, _stringify2.default)(this.userData);
	      localStorage.setItem(this.dataId, stringData);
	    },
	
	    clearUserData: function clearUserData() {
	      if (!localStorageEnabled) return;
	
	      localStorage.removeItem(this.dataId);
	      this.userData = (0, _deepCopy2.default)(this.defaultUserData);
	    }
	  },
	
	  watch: {
	    userData: {
	      handler: function handler(val, oldVal) {
	        this.saveUserData();
	      },
	      deep: true
	    }
	  }
	};

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var staticData = {
	  visibilityOptions: {
	    0: 'Clear',
	    1: 'Light Rain/Fog/Smoke',
	    2: 'Moderate Rain/Fog/Smoke',
	    3: 'Heavy Rain/Fog/Smoke'
	  },
	
	  lightOptions: {
	    0: 'Full Light',
	    1: 'Partial Light',
	    2: 'Dim Light',
	    3: 'Total Darkness'
	  },
	
	  glareOptions: {
	    0: 'No Glare',
	    1: 'Weak Glare',
	    2: 'Moderate Glare',
	    3: 'Blinding Glare'
	  },
	
	  windOptions: {
	    0: 'None or Light Breeze',
	    1: 'Light Winds',
	    2: 'Moderate Winds',
	    3: 'Strong Winds'
	  },
	
	  rangedLOSOptions: {
	    0: 'Direct line of sight to target',
	    1: 'Firing from cover with imaging device',
	    2: 'Firing blind'
	  },
	
	  weaponTypeOptions: {
	    taser: 'Taser',
	    holdout: 'Hold-Out',
	    lPistol: 'Light Pistol',
	    hPistol: 'Heavy Pistol',
	    mPistol: 'Machine Pistol',
	    smg: 'SMG',
	    ar: 'Assault Rifle',
	    fShotgun: 'Shotgun (flechette)',
	    sShotgun: 'Shotgun (slug)',
	    sniper: 'Sniper Rifle',
	    lmg: 'Light Machinegun',
	    hmg: 'Medium/Heavy Machinegun',
	    cannon: 'Assault Cannon',
	    gLaunch: 'Grenade Launcher',
	    mLaunch: 'Missile Launcher',
	    bow: 'Bow',
	    lCross: 'Light Crossbow',
	    mCross: 'Medium Crossbow',
	    hCross: 'Heavy Crossbow',
	    knife: 'Thrown Knife',
	    shuriken: 'Shuriken',
	    sGrenade: 'Standard Grenade',
	    aGrenade: 'Aerodynamic Grenade'
	  },
	
	  compensationGear: {
	    implantedFlareCompensation: 'Flare compensation (implant)',
	    externalFlareCompensation: 'Flare compensation (external)',
	    imageMagnification: 'Image magnification',
	    lowLightVision: 'Low-light vision',
	    thermographicVision: 'Thermographic vision',
	    sunglasses: 'Sunglasses',
	    ultrasound: 'Ultrasound'
	  },
	
	  attackGear: {
	    smartgun: 'Smartgun (wireless)',
	    implantedSmartlink: 'Smartlink (implanted)',
	    externalSmartlink: 'Smartlink (external)',
	    laserSight: 'Laser Sight (wireless)',
	    tracerRounds: 'Tracer rounds',
	    periscope: 'Periscope'
	  },
	
	  rangedSitMods: {
	    firingFromVehicle: 'Firing from moving vehicle',
	    inMeleeCombat: 'In melee combat',
	    running: 'Running',
	    offhand: 'Using off-hand weapon',
	    calledShot: 'Called shot'
	  }
	};
	
	exports.default = staticData;

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ranges = {
	  taser: [0, 5, 10, 15, 20],
	  holdout: [0, 5, 15, 30, 50],
	  lPistol: [0, 5, 15, 30, 50],
	  hPistol: [0, 5, 20, 40, 60],
	  mPistol: [0, 5, 15, 30, 50],
	  smg: [0, 10, 40, 80, 150],
	  ar: [0, 25, 150, 350, 550],
	  fShotgun: [0, 15, 30, 45, 60],
	  sShotgun: [0, 10, 40, 80, 150],
	  sniper: [0, 50, 350, 800, 1500],
	  lmg: [0, 25, 200, 400, 800],
	  hmg: [0, 40, 250, 750, 1200],
	  cannon: [0, 50, 300, 750, 1500],
	  gLaunch: [5, 50, 100, 150, 500],
	  mLaunch: [20, 70, 150, 450, 1500],
	  bow: [0, 1, 10, 30, 60],
	  lCross: [0, 6, 24, 60, 120],
	  mCross: [0, 9, 36, 90, 150],
	  hCross: [0, 15, 45, 120, 180],
	  knife: [0, 1, 2, 3, 5],
	  shuriken: [0, 1, 2, 5, 7],
	  sGrenade: [0, 2, 4, 6, 10],
	  aGrenade: [0, 2, 4, 8, 15]
	};
	
	var strengthWeapons = ['bow', 'knife', 'shuriken', 'sGrenade', 'aGrenade'];
	var noRecoilWeapons = ['bow', 'lCross', 'mCross', 'hCross', 'knife', 'shuriken', 'sGrenade', 'aGrenade'];
	
	exports.default = {
	  isStrengthWeapon: function isStrengthWeapon(weaponType) {
	    return strengthWeapons.indexOf(weaponType) !== -1;
	  },
	
	  hasRecoil: function hasRecoil(weaponType) {
	    return noRecoilWeapons.indexOf(weaponType) === -1;
	  },
	
	  getRange: function getRange(weaponType, strength) {
	    var baseRange = ranges[weaponType];
	
	    if (this.isStrengthWeapon(weaponType)) {
	      return baseRange.map(function (elem) {
	        return elem * strength;
	      });
	    }
	
	    return baseRange;
	  }
	};

/***/ }),
/* 45 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'app',
	  data: function data() {
	    return {
	      title: 'Shadowtools'
	    };
	  },
	
	  components: {}
	};

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'home',
	  data: function data() {
	    return {};
	  }
	};

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var initiativePass = [{ type: 'character', initiative: 22, name: 'Jake Armitage', combatTurn: 4, completed: true }, { type: 'character', initiative: 12, name: 'Six', combatTurn: 4, completed: false, _rowVariant: 'success' }, { type: 'event', initiative: 6, name: 'Grenade', combatTurn: 4, completed: false }];
	
	var upcoming = [{ type: 'event', initiative: 12, name: 'Grenade', combatTurn: 5 }];
	
	var ipTableFields = {
	  initiative: { label: 'Initiative' },
	  name: { label: 'Name' }
	};
	
	var upcomingFields = {
	  combatTurn: { label: 'Combat Turn' },
	  initiative: { label: 'Initiative' },
	  name: { label: 'Name' }
	};
	
	exports.default = {
	  name: 'tracker',
	  data: function data() {
	    return {
	      ipTableItems: initiativePass,
	      ipTableFields: ipTableFields,
	      upcomingItems: upcoming,
	      upcomingFields: upcomingFields,
	      combatTurn: 4,
	      initiative: 12
	    };
	  }
	};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(55);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(58);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _toConsumableArray2 = __webpack_require__(59);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _modifiers = __webpack_require__(43);
	
	var _modifiers2 = _interopRequireDefault(_modifiers);
	
	var _weaponData = __webpack_require__(44);
	
	var _weaponData2 = _interopRequireDefault(_weaponData);
	
	var _settingCol = __webpack_require__(105);
	
	var _settingCol2 = _interopRequireDefault(_settingCol);
	
	var _storage = __webpack_require__(27);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	var _formatters = __webpack_require__(26);
	
	var _formatters2 = _interopRequireDefault(_formatters);
	
	var _deepCopy = __webpack_require__(14);
	
	var _deepCopy2 = _interopRequireDefault(_deepCopy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calcEnvMod(rows) {
	  var maxRow = Math.max.apply(Math, (0, _toConsumableArray3.default)(rows));
	  var maxCount = 0;
	
	  for (var i = 0; i < rows.length; ++i) {
	    var row = rows[i];
	
	    if (row === 0) continue;
	
	    if (row === maxRow) {
	      ++maxCount;
	
	      if (maxCount > 1) {
	        ++maxRow;
	        break;
	      }
	    }
	  }
	
	  var modifiers = [0, -1, -3, -6, -10];
	
	  return modifiers[maxRow];
	}
	
	function calcRangeRow(weaponType, strength, distance) {
	  var weaponRange = _weaponData2.default.getRange(weaponType, strength);
	
	  if (distance < weaponRange[0]) return -1;
	
	  var i = void 0;
	  for (i = 1; i < weaponRange.length; ++i) {
	    if (weaponRange[i] >= distance) break;
	  }
	
	  return i - 1;
	}
	
	function objectToValueSortedPairs(obj) {
	  var keys = (0, _keys2.default)(obj);
	
	  var pairs = [];
	  keys.forEach(function (key) {
	    pairs.push({ key: key, value: obj[key] });
	  });
	
	  pairs.sort(function (a, b) {
	    return a.value.localeCompare(b.value);
	  });
	
	  return pairs;
	}
	
	var defaultUserData = {
	  dicePool: 0,
	  conditionPenalty: 0,
	  strength: 0,
	  willpower: 0,
	
	  weaponType: 'taser',
	  recoilCompensation: 0,
	  weaponRating: 1,
	  ignoreMinRange: false,
	  gear: {},
	
	  visibility: 0,
	  light: 0,
	  glare: 0,
	  wind: 0,
	
	  distance: 0,
	  bulletsFired: 0,
	  wirelessProjectileBonus: 0,
	  takeAimBonus: 0,
	  otherModifiers: 0,
	  rangedLOS: 0,
	  rangedSitMods: {}
	};
	
	var prop = void 0;
	for (prop in (0, _assign2.default)({}, _modifiers2.default.compensationGear, _modifiers2.default.attackGear)) {
	  defaultUserData.gear[prop] = false;
	}
	
	for (prop in _modifiers2.default.rangedSitMods) {
	  defaultUserData.rangedSitMods[prop] = false;
	}
	
	exports.default = {
	  name: 'modifiers',
	  components: { settingCol: _settingCol2.default },
	  mixins: [_storage2.default, _formatters2.default],
	
	  data: function data() {
	    return {
	      dataId: 'modifiers',
	      defaultUserData: defaultUserData,
	      staticData: _modifiers2.default,
	      error: ''
	    };
	  },
	
	
	  methods: {
	    takeAimBonusFormatter: function takeAimBonusFormatter(value) {
	      return this.zeroOrGreater(Math.min(value, this.maxTakeAimBonus));
	    },
	    weaponRatingFormatter: function weaponRatingFormatter(value) {
	      return Math.min(Math.max(value, 1), 10);
	    },
	    limitTakeAim: function limitTakeAim() {
	      this.userData.takeAimBonus = Math.min(this.userData.takeAimBonus, this.maxTakeAimBonus);
	    },
	    clearSituational: function clearSituational() {
	      var situationalParams = ['distance', 'bulletsFired', 'wirelessProjectileBonus', 'takeAimBonus', 'otherModifiers', 'rangedSitMods', 'rangedLOS'];
	
	      for (var i = 0; i < situationalParams.length; ++i) {
	        var param = situationalParams[i];
	        this.userData[param] = (0, _deepCopy2.default)(defaultUserData[param]);
	      }
	    }
	  },
	
	  computed: {
	    allInputValid: function allInputValid() {
	      return this.distanceValid;
	    },
	    distanceValid: function distanceValid() {
	      return this.weaponRange >= 0 && this.weaponRange < 4;
	    },
	    showIgnoreMinRange: function showIgnoreMinRange() {
	      return _weaponData2.default.getRange(this.userData.weaponType, 1)[0] > 0;
	    },
	    showWeaponRating: function showWeaponRating() {
	      return this.userData.weaponType === 'bow';
	    },
	    sortedCompensationTypes: function sortedCompensationTypes() {
	      var combinedAttackGear = (0, _assign2.default)({}, this.staticData.compensationGear, this.staticData.attackGear);
	      return objectToValueSortedPairs(combinedAttackGear);
	    },
	    sortedSitMods: function sortedSitMods() {
	      return objectToValueSortedPairs(this.staticData.rangedSitMods);
	    },
	    distanceDescription: function distanceDescription() {
	      var description = '';
	
	      var ranges = _weaponData2.default.getRange(this.userData.weaponType, this.userData.strength);
	      var minRange = ranges[0];
	      var maxRange = ranges[ranges.length - 1];
	
	      if (minRange > 0) {
	        description += 'Min range: ' + minRange + ' m; max range: ' + maxRange + ' m';
	      } else {
	        description = 'Max range: ' + maxRange + ' m';
	      }
	
	      return description;
	    },
	    weaponHasRecoil: function weaponHasRecoil() {
	      return _weaponData2.default.hasRecoil(this.userData.weaponType);
	    },
	    hasWirelessProjectileBonus: function hasWirelessProjectileBonus() {
	      return this.userData.weaponType === 'shuriken' || this.userData.weaponType === 'knife';
	    },
	    weaponRange: function weaponRange() {
	      var rangeRow = calcRangeRow(this.userData.weaponType, parseInt(this.userData.strength), parseInt(this.userData.distance));
	
	      if (this.userData.ignoreMinRange && rangeRow < 0) {
	        rangeRow = 0;
	      }
	
	      return rangeRow;
	    },
	    compensatedVisibility: function compensatedVisibility() {
	      var visibility = parseInt(this.userData.visibility);
	
	      if (this.userData.gear.thermographicVision) visibility -= 1;
	      if (this.userData.gear.ultrasound) visibility -= 1;
	
	      return Math.max(visibility, 0);
	    },
	    compensatedLight: function compensatedLight() {
	      if (this.userData.gear.ultrasound && this.userData.distance <= 50) {
	        return 0;
	      }
	
	      var light = parseInt(this.userData.light);
	
	      if (this.userData.gear.sunglasses) light += 1;
	
	      if (this.userData.gear.lowLightVision && light <= 2) return 0;
	      if (this.userData.gear.thermographicVision) light -= 1;
	
	      return Math.max(light, 0);
	    },
	    compensatedGlare: function compensatedGlare() {
	      var glare = parseInt(this.userData.glare);
	
	      if (this.userData.gear.implantedFlareCompensation || this.userData.gear.externalFlareCompensation) glare -= 2;
	      if (this.userData.gear.sunglasses) glare -= 1;
	
	      return Math.max(glare, 0);
	    },
	    compensatedWind: function compensatedWind() {
	      var wind = parseInt(this.userData.wind);
	
	      if (this.userData.gear.tracerRounds && wind > 1) wind -= 1;
	      if (this.userData.gear.implantedSmartlink || this.userData.gear.externalSmartLink) wind -= 1;
	
	      return Math.max(wind, 0);
	    },
	    compensatedWeaponRange: function compensatedWeaponRange() {
	      var range = parseInt(this.weaponRange);
	
	      if (this.userData.gear.imageMagnification) range -= 1;
	      if (this.userData.gear.tracerRounds) range -= 1;
	
	      return Math.max(range, 0);
	    },
	    maxTakeAimBonus: function maxTakeAimBonus() {
	      return Math.ceil(this.userData.willpower / 2);
	    },
	    totalRecoilCompensation: function totalRecoilCompensation() {
	      return 1 + Math.ceil(parseInt(this.userData.strength) / 3) + parseInt(this.userData.recoilCompensation);
	    },
	    totalModifier: function totalModifier() {
	      var envRows = [this.compensatedVisibility, this.compensatedLight, this.compensatedGlare, this.compensatedWind, this.compensatedWeaponRange];
	
	      var finalMod = calcEnvMod(envRows);
	
	      var smartgunBonus = 0;
	      if (this.userData.gear.smartgun) {
	        if (this.userData.gear.implantedSmartlink) smartgunBonus = 2;else if (this.userData.gear.externalSmartlink) smartgunBonus = 1;
	      }
	      finalMod += smartgunBonus;
	
	      if (smartgunBonus === 0 && this.userData.gear.laserSight) finalMod += 1;
	
	      if (this.userData.rangedSitMods.calledShot) finalMod -= 4;
	      if (this.userData.rangedSitMods.firingFromVehicle) finalMod -= 2;
	      if (this.userData.rangedSitMods.inMeleeCombat) finalMod -= 3;
	      if (this.userData.rangedSitMods.running) finalMod -= 2;
	      if (this.userData.rangedSitMods.offhand) finalMod -= 2;
	
	      finalMod -= parseInt(this.userData.conditionPenalty);
	      finalMod += parseInt(this.userData.takeAimBonus);
	      finalMod += parseInt(this.userData.otherModifiers);
	
	      finalMod -= parseInt(this.userData.rangedLOS) * 3;
	
	      if (this.userData.weaponType === 'bow') {
	        var strengthDiff = this.userData.strength - this.userData.weaponRating;
	        if (strengthDiff < 0) finalMod += strengthDiff * 3;
	      }
	
	      if (this.weaponHasRecoil) {
	        var recoilTotal = this.totalRecoilCompensation - parseInt(this.userData.bulletsFired);
	        if (recoilTotal < 0) finalMod += recoilTotal;
	      }
	
	      if (this.hasWirelessProjectileBonus) {
	        finalMod += parseInt(this.userData.wirelessProjectileBonus);
	      }
	
	      return finalMod;
	    },
	
	    totalDicePoolString: function totalDicePoolString() {
	      var totalDicePool = parseInt(this.userData.dicePool) + this.totalModifier;
	
	      if (totalDicePool < 0) {
	        return '0 (' + totalDicePool + ')';
	      }
	
	      return totalDicePool;
	    }
	  }
	};

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'setting-col',
	
	  props: {
	    widthScale: {
	      type: Number,
	      default: 1
	    }
	  },
	
	  computed: {
	    className: function className() {
	      var smWidth = 6 * this.widthScale;
	      var mdWidth = 4 * this.widthScale;
	      var lgWidth = 3 * this.widthScale;
	
	      return 'col-sm-' + smWidth + ' col-md-' + mdWidth + ' col-lg-' + lgWidth;
	    }
	  }
	};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _randomJs = __webpack_require__(99);
	
	var _randomJs2 = _interopRequireDefault(_randomJs);
	
	var _deepCopy = __webpack_require__(14);
	
	var _deepCopy2 = _interopRequireDefault(_deepCopy);
	
	var _diceTools = __webpack_require__(25);
	
	var _diceTools2 = _interopRequireDefault(_diceTools);
	
	var _formatters = __webpack_require__(26);
	
	var _formatters2 = _interopRequireDefault(_formatters);
	
	var _storage = __webpack_require__(27);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	var _rollInfo = __webpack_require__(108);
	
	var _rollInfo2 = _interopRequireDefault(_rollInfo);
	
	var _vueFontawesome = __webpack_require__(23);
	
	var _vueFontawesome2 = _interopRequireDefault(_vueFontawesome);
	
	var _edgeMode = __webpack_require__(24);
	
	var _edgeMode2 = _interopRequireDefault(_edgeMode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var random = new _randomJs2.default(_randomJs2.default.engines.mt19937().autoSeed());
	
	var defaultUserData = {
	  rollSettings: {
	    dicePool: 0,
	    limit: 0,
	    baseValue: 0,
	    useLimit: true,
	    label: '',
	    mode: 'hits'
	  },
	
	  edge: 0,
	  presets: [],
	  rollHistory: [],
	
	  animateDice: true
	};
	
	exports.default = {
	  name: 'roller',
	  mixins: [_storage2.default, _formatters2.default, _diceTools2.default],
	  components: { rollInfo: _rollInfo2.default, FontAwesomeIcon: _vueFontawesome2.default },
	
	  data: function data() {
	    return {
	      dataId: 'roller',
	      defaultUserData: defaultUserData,
	      pushLimitRollId: null,
	
	      rollsToAnimate: []
	    };
	  },
	
	
	  methods: {
	    addRollToAnimate: function addRollToAnimate(rollId) {
	      if (this.rollsToAnimate.indexOf(rollId) !== -1) return;
	
	      this.rollsToAnimate.push(rollId);
	    },
	    clearRollHistory: function clearRollHistory() {
	      this.userData.rollHistory = [];
	    },
	    closeCall: function closeCall(rollId) {
	      this.getRoll(rollId).edgeMode = _edgeMode2.default.CLOSE_CALL;
	    },
	    createRoll: function createRoll(toPushTheLimit) {
	      var dicePool = parseInt(this.userData.rollSettings.dicePool);
	      if (toPushTheLimit) dicePool += parseInt(this.userData.edge);
	
	      var dice = [];
	      this.rollDice(dice, dicePool, toPushTheLimit);
	
	      var date = new Date();
	      var newId = this.nextRollSettingsId();
	
	      var newRoll = {
	        dicePool: this.userData.rollSettings.dicePool,
	        label: this.userData.rollSettings.label || date.toLocaleTimeString(),
	        dice: dice,
	        id: newId,
	        date: date.toISOString(),
	        edge: this.userData.edge,
	        edgeMode: toPushTheLimit ? _edgeMode2.default.PUSH_LIMIT_PRE : _edgeMode2.default.NONE,
	        mode: this.userData.rollSettings.mode
	      };
	
	      if (newRoll.mode === 'hits') {
	        newRoll.limit = this.userData.rollSettings.useLimit ? this.userData.rollSettings.limit : null;
	      } else if (newRoll.mode === 'sum') {
	        newRoll.baseValue = this.userData.rollSettings.baseValue;
	      }
	
	      this.userData.rollHistory.push(newRoll);
	
	      this.addRollToAnimate(newId);
	    },
	    deletePreset: function deletePreset() {
	      var presetIndex = this.getPresetIndex(this.userData.rollSettings.label);
	
	      if (presetIndex === -1) return;
	
	      this.userData.presets.splice(presetIndex, 1);
	    },
	    deleteRoll: function deleteRoll(rollId) {
	      var rollIndex = this.userData.rollHistory.findIndex(function (roll) {
	        return roll.id === rollId;
	      });
	      this.userData.rollHistory.splice(rollIndex, 1);
	
	      var toAnimateIndex = this.rollsToAnimate.indexOf(rollId);
	      if (toAnimateIndex !== -1) {
	        this.rollsToAnimate.splice(toAnimateIndex, 1);
	      }
	    },
	    getPresetIndex: function getPresetIndex(label) {
	      return this.userData.presets.findIndex(function (preset) {
	        return preset.label === label;
	      });
	    },
	    getRoll: function getRoll(rollId) {
	      return this.userData.rollHistory.find(function (roll) {
	        return roll.id === rollId;
	      });
	    },
	    loadPreset: function loadPreset(preset) {
	      this.userData.rollSettings = (0, _deepCopy2.default)(preset);
	    },
	    modePresets: function modePresets(mode) {
	      var presets = [];
	
	      for (var i = 0; i < this.userData.presets.length; ++i) {
	        var preset = this.userData.presets[i];
	        if (preset.mode === mode) presets.push(preset);
	      }
	
	      presets.sort(function (a, b) {
	        return a.label.localeCompare(b.label);
	      });
	
	      return presets;
	    },
	    nextRollSettingsId: function nextRollSettingsId() {
	      return this.userData.rollHistory.reduce(function (max, roll) {
	        return isNaN(roll.id) ? max : Math.max(max, roll.id);
	      }, 0) + 1;
	    },
	    pushLimitOk: function pushLimitOk() {
	      if (this.pushLimitRollId === null) {
	        this.createRoll(true);
	      } else {
	        var roll = this.getRoll(this.pushLimitRollId);
	
	        this.rollDice(roll.dice, this.userData.edge, true);
	        roll.edgeMode = _edgeMode2.default.PUSH_LIMIT_POST;
	
	        this.addRollToAnimate(roll.id);
	      }
	    },
	    pushLimit: function pushLimit(rollId) {
	      this.pushLimitRollId = rollId;
	      this.$root.$emit('bv::show::modal', 'pushLimitModal');
	    },
	    rollDice: function rollDice(rollList, dicePool, explode) {
	      var diceToRoll = dicePool;
	
	      while (diceToRoll > 0) {
	        var result = [];
	        for (var i = 0; i < diceToRoll; ++i) {
	          result.push(random.integer(1, 6));
	        }
	
	        rollList.push(result);
	
	        if (!explode) break;
	
	        diceToRoll = result.reduce(function (sixes, value) {
	          return value === 6 ? sixes + 1 : sixes;
	        }, 0);
	      }
	    },
	    savePreset: function savePreset() {
	      var rollSettings = this.userData.rollSettings;
	      if (!rollSettings.label) return;
	
	      var settingsCopy = (0, _deepCopy2.default)(rollSettings);
	
	      var presetIndex = this.getPresetIndex(rollSettings.label);
	
	      if (presetIndex === -1) {
	        this.userData.presets.push(settingsCopy);
	      } else {
	        this.userData.presets.splice(presetIndex, 1, settingsCopy);
	      }
	    },
	    secondChance: function secondChance(rollId) {
	      var roll = this.getRoll(rollId);
	      roll.edgeMode = _edgeMode2.default.SECOND_CHANCE;
	
	      var hits = this.calcTotalHits(roll.dice);
	      this.rollDice(roll.dice, roll.dicePool - hits, false);
	
	      this.addRollToAnimate(roll.id);
	    }
	  },
	
	  computed: {
	    reversedHistory: function reversedHistory() {
	      return this.userData.rollHistory.slice().reverse();
	    },
	    hitsPresets: function hitsPresets() {
	      return this.modePresets('hits');
	    },
	    sumPresets: function sumPresets() {
	      return this.modePresets('sum');
	    }
	  }
	};

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'die',
	
	  props: {
	    frameLength: {
	      type: Number,
	      default: 1
	    },
	
	    highlightSix: {
	      type: Boolean,
	      default: false
	    },
	
	    highlightOne: {
	      type: Boolean,
	      default: true
	    },
	
	    noHighlight: {
	      type: Boolean,
	      default: false
	    },
	
	    rolling: {
	      type: Boolean,
	      default: false
	    },
	
	    value: {
	      type: Number,
	      default: 1
	    }
	  },
	
	  created: function created() {
	    this.animate();
	    this.updateTimer();
	  },
	  updated: function updated() {
	    this.updateTimer();
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	  },
	  data: function data() {
	    return {
	      displayedValue: 1,
	      nextFrameDelay: 0,
	      timer: ''
	    };
	  },
	
	
	  methods: {
	    animate: function animate() {
	      if (this.nextFrameDelay) {
	        --this.nextFrameDelay;
	        return;
	      }
	
	      this.$emit('onFrame');
	
	      if (!this.rolling) this.displayedValue = this.value;else this.displayedValue = 1 + Math.floor(Math.random() * Math.floor(6));
	
	      this.nextFrameDelay = this.frameLength - 1;
	    },
	    updateTimer: function updateTimer() {
	      if (this.rolling && !this.timer) {
	        this.timer = setInterval(this.animate, Math.random() * 20 + 40);
	      }
	
	      if (!this.rolling && this.timer) {
	        clearInterval(this.timer);
	        this.timer = null;
	        this.displayedValue = this.value;
	      }
	    }
	  },
	
	  computed: {
	    svgName: function svgName() {
	      var color = 'secondary';
	
	      if (this.rolling) {
	        color = 'muted';
	      } else if (this.noHighlight) {
	          color = 'white';
	        } else {
	            if (this.displayedValue === 1 && this.highlightOne) color = 'danger';else if (this.displayedValue === 5) color = 'success';else if (this.displayedValue === 6) {
	              if (this.highlightSix) color = 'warning';else color = 'success';
	            }
	          }
	
	      return 'diecon text-' + color;
	    },
	    xlinkName: function xlinkName() {
	      return '#diecon-' + this.displayedValue;
	    }
	  }
	};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diceTools = __webpack_require__(25);
	
	var _diceTools2 = _interopRequireDefault(_diceTools);
	
	var _die = __webpack_require__(107);
	
	var _die2 = _interopRequireDefault(_die);
	
	var _vueFontawesome = __webpack_require__(23);
	
	var _vueFontawesome2 = _interopRequireDefault(_vueFontawesome);
	
	var _edgeMode = __webpack_require__(24);
	
	var _edgeMode2 = _interopRequireDefault(_edgeMode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var startGroupWait = 10;
	
	var endGroupWait = 5;
	
	exports.default = {
	  name: 'roll-info',
	  mixins: [_diceTools2.default],
	  components: { die: _die2.default, FontAwesomeIcon: _vueFontawesome2.default },
	
	  data: function data() {
	    return {
	      EdgeMode: _edgeMode2.default,
	
	      showEditIcon: false,
	
	      isEditingLabel: false,
	
	      dieFrameLength: 1,
	      nextFrameDelay: startGroupWait,
	      readyToRevealDie: false,
	      revealedDie: 0,
	      revealedGroup: 0,
	      timer: '',
	      waitForNextGroup: false
	    };
	  },
	  created: function created() {
	    this.updateTimer();
	  },
	  updated: function updated() {
	    if (this.animate && this.revealedGroup === 0 && (this.roll.edgeMode === _edgeMode2.default.PUSH_LIMIT_POST || this.roll.edgeMode === _edgeMode2.default.SECOND_CHANCE)) {
	      this.revealedGroup = 1;
	    }
	    this.updateTimer();
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.timer);
	  },
	
	
	  props: {
	    animate: {
	      type: Boolean,
	      default: true
	    },
	
	    frameTime: {
	      type: Number,
	      default: 100
	    },
	
	    roll: {
	      type: Object
	    }
	  },
	
	  computed: {
	    baseHits: function baseHits() {
	      return this.calcGroupHits(this.roll.dice[0]);
	    },
	    baseMisses: function baseMisses() {
	      return this.calcGroupMisses(this.roll.dice[0]);
	    },
	    date: function date() {
	      return new Date(this.roll.date).toLocaleString();
	    },
	    edgeModeString: function edgeModeString() {
	      if (this.roll.edgeMode === _edgeMode2.default.NONE) return '';
	
	      if (this.usedPushTheLimit) {
	        var preEdge = this.roll.edgeMode === _edgeMode2.default.PUSH_LIMIT_PRE;
	
	        return 'Used Push the Limit (' + (preEdge ? 'pre' : 'post') + '-roll) for an extra ' + this.roll.edge + ' ' + this.$options.filters.pluralize(this.roll.edge, 'die', 'dice') + '; ' + this.rerollDicePool + ' ' + this.$options.filters.pluralize(this.rerollDicePool, 'six', 'sixes') + ' exploded';
	      }
	
	      if (this.roll.edgeMode === _edgeMode2.default.SECOND_CHANCE) {
	        var str = 'Used Second Chance to reroll ' + this.rerollDicePool + ' ' + this.$options.filters.pluralize(this.rerollDicePool, 'die', 'dice');
	
	        if (this.baseMisses > 0) {
	          str += ', negating ' + this.baseMisses + ' ' + this.$options.filters.pluralize(this.baseMisses, 'miss', 'misses');
	        }
	
	        return str;
	      }
	
	      if (this.roll.edgeMode === _edgeMode2.default.CLOSE_CALL) {
	        var _str = 'Used Close Call, ';
	
	        if (this.glitchLevel === 0) {
	          _str += 'negating the glitch';
	        }
	
	        if (this.glitchLevel === 1) {
	          _str += 'turning critical glitch into a regular glitch';
	        }
	
	        return _str;
	      }
	
	      return '';
	    },
	    glitchLevel: function glitchLevel() {
	      var usedSecondChance = this.roll.edgeMode === _edgeMode2.default.SECOND_CHANCE;
	      var misses = usedSecondChance ? this.baseMisses : this.totalMisses;
	      var hits = usedSecondChance ? this.baseHits : this.totalHits;
	      var dicePool = usedSecondChance ? this.roll.dicePool : this.totalDicePool;
	
	      var level = 0;
	      if (misses > dicePool / 2) {
	        if (hits === 0) level = 2;else level = 1;
	
	        if (this.roll.edgeMode === _edgeMode2.default.CLOSE_CALL) --level;
	      }
	
	      return level;
	    },
	    isAnimating: function isAnimating() {
	      return this.animate && this.revealedGroup < this.roll.dice.length;
	    },
	    isHitsMode: function isHitsMode() {
	      return this.roll.mode === 'hits';
	    },
	    isLimited: function isLimited() {
	      return this.roll.limit != null && !this.usedPushTheLimit;
	    },
	    isSumMode: function isSumMode() {
	      return this.roll.mode === 'sum';
	    },
	    limitedHits: function limitedHits() {
	      if (!this.isLimited) return this.totalHits;
	
	      return Math.min(this.totalHits, this.roll.limit);
	    },
	    rerolledDice: function rerolledDice() {
	      if (this.roll.edgeMode === _edgeMode2.default.PUSH_LIMIT_PRE || this.roll.edgeMode === _edgeMode2.default.SECOND_CHANCE) {
	        return this.roll.dice.slice(1);
	      }
	      if (this.roll.edgeMode === _edgeMode2.default.PUSH_LIMIT_POST) {
	        return this.roll.dice.slice(2);
	      }
	      return [];
	    },
	    rerollDicePool: function rerollDicePool() {
	      return this.calcDicePool(this.rerolledDice);
	    },
	    rerollHits: function rerollHits() {
	      return this.calcTotalHits(this.rerolledDice);
	    },
	    rerollMisses: function rerollMisses() {
	      return this.calcTotalMisses(this.rerolledDice);
	    },
	    rollModified: function rollModified() {
	      return this.usedPushTheLimit || this.roll.edgeMode === _edgeMode2.default.SECOND_CHANCE;
	    },
	    sum: function sum() {
	      return this.calcSum(this.roll.dice) + parseInt(this.roll.baseValue);
	    },
	    totalHits: function totalHits() {
	      return this.calcTotalHits(this.roll.dice);
	    },
	    totalMisses: function totalMisses() {
	      if (this.roll.edgeMode === _edgeMode2.default.SECOND_CHANCE) {
	        return this.calcTotalMisses(this.roll.dice.slice(1));
	      }
	
	      return this.calcTotalMisses(this.roll.dice);
	    },
	    totalDicePool: function totalDicePool() {
	      return this.calcDicePool(this.roll.dice);
	    },
	    usedPushTheLimit: function usedPushTheLimit() {
	      var pushLimitModes = [this.EdgeMode.PUSH_LIMIT_PRE, this.EdgeMode.PUSH_LIMIT_POST];
	      return pushLimitModes.includes(this.roll.edgeMode);
	    }
	  },
	
	  methods: {
	    endEditLabel: function endEditLabel() {
	      this.isEditingLabel = false;
	      this.showEditIcon = false;
	    },
	    getHitString: function getHitString(hits, limit, ignoreLimit) {
	      if (ignoreLimit) {
	        return hits + ' ' + this.$options.filters.pluralize(hits, 'hit');
	      }
	
	      var limitedHits = Math.min(hits, limit);
	      var str = limitedHits + ' ' + this.$options.filters.pluralize(limitedHits, 'hit');
	      if (hits > limit) {
	        str += ' (' + hits + ' before limit)';
	      }
	
	      return str;
	    },
	    getMissString: function getMissString(misses) {
	      return misses + ' ' + this.$options.filters.pluralize(misses, 'miss', 'misses');
	    },
	    onAnimate: function onAnimate() {
	      if (this.revealedGroup >= this.roll.dice.length) return;
	
	      if (this.nextFrameDelay) {
	        --this.nextFrameDelay;
	        return;
	      }
	
	      if (this.waitForNextGroup) {
	        this.revealedDie = 0;
	        ++this.revealedGroup;
	
	        this.nextFrameDelay = startGroupWait;
	        this.waitForNextGroup = false;
	
	        return;
	      }
	
	      this.readyToRevealDie = true;
	    },
	    revealDie: function revealDie() {
	      if (!this.readyToRevealDie) return;
	
	      ++this.revealedDie;
	
	      this.dieFrameLength = 1;
	
	      var groupDice = this.roll.dice[this.revealedGroup].length;
	
	      if (this.revealedDie === groupDice - 1) {
	        this.nextFrameDelay = 10;
	        this.dieFrameLength = 8;
	      } else if (this.revealedDie === groupDice - 2) {
	        this.nextFrameDelay = 6;
	        this.dieFrameLength = 6;
	      } else if (this.revealedDie === groupDice - 3) {
	        this.nextFrameDelay = 5;
	        this.dieFrameLength = 4;
	      } else if (this.revealedDie >= groupDice - 6) {
	        this.nextFrameDelay = 2;
	        this.dieFrameLength = 2;
	      }
	
	      if (this.revealedDie >= groupDice) {
	        this.nextFrameDelay = endGroupWait;
	        this.waitForNextGroup = true;
	      }
	
	      this.readyToRevealDie = false;
	    },
	    startEditLabel: function startEditLabel() {
	      this.isEditingLabel = true;
	      this.$nextTick(function () {
	        this.$refs.labelInput.focus();
	      });
	    },
	    updateTimer: function updateTimer() {
	      if (this.isAnimating && !this.timer) {
	        this.timer = setInterval(this.onAnimate, this.frameTime);
	      } else if (!this.isAnimating && this.timer) {
	          clearInterval(this.timer);
	          this.timer = null;
	        }
	    }
	  }
	};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _create = __webpack_require__(56);
	
	var _create2 = _interopRequireDefault(_create);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*!
	 * @copyright Copyright (c) 2017 IcoMoon.io
	 * @license   Licensed under MIT license
	 *            See https://github.com/Keyamoon/svgxuse
	 * @version   1.2.6
	 */
	(function () {
	    "use strict";
	
	    if (typeof window !== "undefined" && window.addEventListener) {
	        var cache = (0, _create2.default)(null);
	        var checkUseElems;
	        var tid;
	        var debouncedCheck = function debouncedCheck() {
	            clearTimeout(tid);
	            tid = setTimeout(checkUseElems, 100);
	        };
	        var unobserveChanges = function unobserveChanges() {
	            return;
	        };
	        var observeChanges = function observeChanges() {
	            var observer;
	            window.addEventListener("resize", debouncedCheck, false);
	            window.addEventListener("orientationchange", debouncedCheck, false);
	            if (window.MutationObserver) {
	                observer = new MutationObserver(debouncedCheck);
	                observer.observe(document.documentElement, {
	                    childList: true,
	                    subtree: true,
	                    attributes: true
	                });
	                unobserveChanges = function unobserveChanges() {
	                    try {
	                        observer.disconnect();
	                        window.removeEventListener("resize", debouncedCheck, false);
	                        window.removeEventListener("orientationchange", debouncedCheck, false);
	                    } catch (ignore) {}
	                };
	            } else {
	                document.documentElement.addEventListener("DOMSubtreeModified", debouncedCheck, false);
	                unobserveChanges = function unobserveChanges() {
	                    document.documentElement.removeEventListener("DOMSubtreeModified", debouncedCheck, false);
	                    window.removeEventListener("resize", debouncedCheck, false);
	                    window.removeEventListener("orientationchange", debouncedCheck, false);
	                };
	            }
	        };
	        var createRequest = function createRequest(url) {
	            function getOrigin(loc) {
	                var a;
	                if (loc.protocol !== undefined) {
	                    a = loc;
	                } else {
	                    a = document.createElement("a");
	                    a.href = loc;
	                }
	                return a.protocol.replace(/:/g, "") + a.host;
	            }
	            var Request;
	            var origin;
	            var origin2;
	            if (window.XMLHttpRequest) {
	                Request = new XMLHttpRequest();
	                origin = getOrigin(location);
	                origin2 = getOrigin(url);
	                if (Request.withCredentials === undefined && origin2 !== "" && origin2 !== origin) {
	                    Request = XDomainRequest || undefined;
	                } else {
	                    Request = XMLHttpRequest;
	                }
	            }
	            return Request;
	        };
	        var xlinkNS = "http://www.w3.org/1999/xlink";
	        checkUseElems = function checkUseElems() {
	            var base;
	            var bcr;
	            var fallback = "";
	            var hash;
	            var href;
	            var i;
	            var inProgressCount = 0;
	            var isHidden;
	            var Request;
	            var url;
	            var uses;
	            var xhr;
	            function observeIfDone() {
	                inProgressCount -= 1;
	                if (inProgressCount === 0) {
	                    unobserveChanges();
	                    observeChanges();
	                }
	            }
	            function attrUpdateFunc(spec) {
	                return function () {
	                    if (cache[spec.base] !== true) {
	                        spec.useEl.setAttributeNS(xlinkNS, "xlink:href", "#" + spec.hash);
	                        if (spec.useEl.hasAttribute("href")) {
	                            spec.useEl.setAttribute("href", "#" + spec.hash);
	                        }
	                    }
	                };
	            }
	            function onloadFunc(xhr) {
	                return function () {
	                    var body = document.body;
	                    var x = document.createElement("x");
	                    var svg;
	                    xhr.onload = null;
	                    x.innerHTML = xhr.responseText;
	                    svg = x.getElementsByTagName("svg")[0];
	                    if (svg) {
	                        svg.setAttribute("aria-hidden", "true");
	                        svg.style.position = "absolute";
	                        svg.style.width = 0;
	                        svg.style.height = 0;
	                        svg.style.overflow = "hidden";
	                        body.insertBefore(svg, body.firstChild);
	                    }
	                    observeIfDone();
	                };
	            }
	            function onErrorTimeout(xhr) {
	                return function () {
	                    xhr.onerror = null;
	                    xhr.ontimeout = null;
	                    observeIfDone();
	                };
	            }
	            unobserveChanges();
	            uses = document.getElementsByTagName("use");
	            for (i = 0; i < uses.length; i += 1) {
	                try {
	                    bcr = uses[i].getBoundingClientRect();
	                } catch (ignore) {
	                    bcr = false;
	                }
	                href = uses[i].getAttribute("href") || uses[i].getAttributeNS(xlinkNS, "href") || uses[i].getAttribute("xlink:href");
	                if (href && href.split) {
	                    url = href.split("#");
	                } else {
	                    url = ["", ""];
	                }
	                base = url[0];
	                hash = url[1];
	                isHidden = bcr && bcr.left === 0 && bcr.right === 0 && bcr.top === 0 && bcr.bottom === 0;
	                if (bcr && bcr.width === 0 && bcr.height === 0 && !isHidden) {
	                    if (fallback && !base.length && hash && !document.getElementById(hash)) {
	                        base = fallback;
	                    }
	                    if (uses[i].hasAttribute("href")) {
	                        uses[i].setAttributeNS(xlinkNS, "xlink:href", href);
	                    }
	                    if (base.length) {
	                        xhr = cache[base];
	                        if (xhr !== true) {
	                            setTimeout(attrUpdateFunc({
	                                useEl: uses[i],
	                                base: base,
	                                hash: hash
	                            }), 0);
	                        }
	                        if (xhr === undefined) {
	                            Request = createRequest(base);
	                            if (Request !== undefined) {
	                                xhr = new Request();
	                                cache[base] = xhr;
	                                xhr.onload = onloadFunc(xhr);
	                                xhr.onerror = onErrorTimeout(xhr);
	                                xhr.ontimeout = onErrorTimeout(xhr);
	                                xhr.open("GET", base);
	                                xhr.send();
	                                inProgressCount += 1;
	                            }
	                        }
	                    }
	                } else {
	                    if (!isHidden) {
	                        if (cache[base] === undefined) {
	                            cache[base] = true;
	                        } else if (cache[base].onload) {
	                            cache[base].abort();
	                            delete cache[base].onload;
	                            cache[base] = true;
	                        }
	                    } else if (base.length && cache[base]) {
	                        setTimeout(attrUpdateFunc({
	                            useEl: uses[i],
	                            base: base,
	                            hash: hash
	                        }), 0);
	                    }
	                }
	            }
	            uses = "";
	            inProgressCount += 1;
	            observeIfDone();
	        };
	        var _winLoad;
	        _winLoad = function winLoad() {
	            window.removeEventListener("load", _winLoad, false);
	            tid = setTimeout(checkUseElems, 0);
	        };
	        if (document.readyState !== "complete") {
	            window.addEventListener("load", _winLoad, false);
	        } else {
	            _winLoad();
	        }
	    }
	})();

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */,
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/logo.06f082a.png";

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(98)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(45),
	  /* template */
	  __webpack_require__(113),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(46),
	  /* template */
	  __webpack_require__(109),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(47),
	  /* template */
	  __webpack_require__(116),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(48),
	  /* template */
	  __webpack_require__(110),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(49),
	  /* template */
	  __webpack_require__(112),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(50),
	  /* template */
	  __webpack_require__(114),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(51),
	  /* template */
	  __webpack_require__(115),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(52),
	  /* template */
	  __webpack_require__(111),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "home"
	  }, [_c('div', {
	    staticClass: "text-center"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(100)
	    }
	  }), _vm._v(" "), _c('h1', [_vm._v("Welcome to Shadowtools!")]), _vm._v(" "), _c('p', {
	    staticClass: "lead"
	  }, [_vm._v("\n      Click on the navigation links above to access the tools.\n    ")])])])
	}]}

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modifiers"
	  }, [_c('b-form-fieldset', [_c('legend', [_vm._v("Character")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('setting-col', [_c('b-form-group', {
	    attrs: {
	      "label": "Initial dice pool",
	      "description": "Usually AGI + weapon skill."
	    }
	  }, [_c('b-form-input', {
	    attrs: {
	      "type": "number",
	      "formatter": _vm.zeroOrGreater,
	      "lazy-formatter": ""
	    },
	    model: {
	      value: (_vm.userData.dicePool),
	      callback: function($$v) {
	        _vm.userData.dicePool = $$v
	      },
	      expression: "userData.dicePool"
	    }
	  })], 1)], 1), _vm._v(" "), _c('setting-col', [_c('b-form-group', {
	    attrs: {
	      "label": "Condition monitor penalty"
	    }
	  }, [_c('b-input-group', {
	    attrs: {
	      "left": "-"
	    }
	  }, [_c('b-form-input', {
	    attrs: {
	      "type": "number",
	      "formatter": _vm.zeroOrGreater,
	      "lazy-formatter": ""
	    },
	    model: {
	      value: (_vm.userData.conditionPenalty),
	      callback: function($$v) {
	        _vm.userData.conditionPenalty = $$v
	      },
	      expression: "userData.conditionPenalty"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('setting-col', [_c('b-form-group', {
	    attrs: {
	      "label": "Strength"
	    }
	  }, [_c('b-form-input', {
	    attrs: {
	      "type": "number",
	      "formatter": _vm.zeroOrGreater,
	      "lazy-formatter": ""
	    },
	    model: {
	      value: (_vm.userData.strength),
	      callback: function($$v) {
	        _vm.userData.strength = $$v
	      },
	      expression: "userData.strength"
	    }
	  })], 1)], 1), _vm._v(" "), _c('setting-col', [_c('b-form-group', {
	    attrs: {
	      "label": "Willpower"
	    }
	  }, [_c('b-form-input', {
	    attrs: {
	      "type": "number",
	      "formatter": _vm.zeroOrGreater,
	      "lazy-formatter": ""
	    },
	    on: {
	      "change": _vm.limitTakeAim
	    },
	    model: {
	      value: (_vm.userData.willpower),
	      callback: function($$v) {
	        _vm.userData.willpower = $$v
	      },
	      expression: "userData.willpower"
	    }
	  })], 1)], 1)], 1)]), _vm._v(" "), _c('b-form-fieldset', [_c('legend', [_vm._v("Gear")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('setting-col', [_c('b-form-group', {
	    attrs: {
	      "label": "Weapon type"
	    }
	  }, [_c('b-form-select', {
	    attrs: {
	      "options": _vm.staticData.weaponTypeOptions
	    },
	    model: {
	      value: (_vm.userData.weaponType),
	      callback: function($$v) {
	        _vm.userData.weaponType = $$v
	      },
	      expression: "userData.weaponType"
	    }
	  })], 1)], 1), _vm._v(" "), (_vm.weaponHasRecoil) ? _c('setting-col', [_c('b-form-group', {
	    attrs: {
	      "label": "Total recoil compensation",
	      "description": "The total for all weapons you're firing this Action Phase."
	    }
	  }, [_c('b-form-input', {
	    attrs: {
	      "type": "number",
	      "formatter": _vm.zeroOrGreater,
	      "lazy-formatter": ""
	    },
	    model: {
	      value: (_vm.userData.recoilCompensation),
	      callback: function($$v) {
	        _vm.userData.recoilCompensation = $$v
	      },
	      expression: "userData.recoilCompensation"
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('setting-col', [(_vm.showWeaponRating) ? _c('b-form-group', {
	    attrs: {
	      "label": "Weapon rating"
	    }
	  }, [_c('b-form-input', {
	    attrs: {
	      "type": "number",
	      "formatter": _vm.weaponRatingFormatter,
	      "lazy-formatter": ""
	    },
	    model: {
	      value: (_vm.userData.weaponRating),
	      callback: function($$v) {
	        _vm.userData.weaponRating = $$v
	      },
	      expression: "userData.weaponRating"
	    }
	  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.showIgnoreMinRange) ? _c('div', [_c('b-form-checkbox', {
	    model: {
	      value: (_vm.userData.ignoreMinRange),
	      callback: function($$v) {
	        _vm.userData.ignoreMinRange = $$v
	      },
	      expression: "userData.ignoreMinRange"
	    }
	  }, [_vm._v("\n        Ignore minimum range\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('b-form-group', {
	    attrs: {
	      "label": "Environmental compensation"
	    }
	  }, _vm._l((_vm.sortedCompensationTypes), function(pair) {
	    return _c('b-form-checkbox', {
	      key: pair.key,
	      model: {
	        value: (_vm.userData.gear[pair.key]),
	        callback: function($$v) {
	          _vm.$set(_vm.userData.gear, pair.key, $$v)
	        },
	        expression: "userData.gear[pair.key]"
	      }
	    }, [_vm._v("\n        " + _vm._s(pair.value) + "\n      ")])
	  }))], 1), _vm._v(" "), _c('b-form-fieldset', [_c('legend', [_vm._v("Environment")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('setting-col', [_c('b-form-group', {
	    attrs: {
	      "label": "Visibility"
	    }
	  }, [_c('b-form-select', {
	    attrs: {
	      "options": _vm.staticData.visibilityOptions
	    },
	    model: {
	      value: (_vm.userData.visibility),
	      callback: function($$v) {
	        _vm.userData.visibility = $$v
	      },
	      expression: "userData.visibility"
	    }
	  })], 1)], 1), _vm._v(" "), _c('setting-col', [_c('b-form-group', {
	    attrs: {
	      "label": "Light"
	    }
	  }, [_c('b-form-select', {
	    attrs: {
	      "options": _vm.staticData.lightOptions
	    },
	    model: {
	      value: (_vm.userData.light),
	      callback: function($$v) {
	        _vm.userData.light = $$v
	      },
	      expression: "userData.light"
	    }
	  })], 1)], 1), _vm._v(" "), _c('setting-col', [_c('b-form-group', {
	    attrs: {
	      "label": "Glare"
	    }
	  }, [_c('b-form-select', {
	    attrs: {
	      "options": _vm.staticData.glareOptions
	    },
	    model: {
	      value: (_vm.userData.glare),
	      callback: function($$v) {
	        _vm.userData.glare = $$v
	      },
	      expression: "userData.glare"
	    }
	  })], 1)], 1), _vm._v(" "), _c('setting-col', [_c('b-form-group', {
	    attrs: {
	      "label": "Wind"
	    }
	  }, [_c('b-form-select', {
	    attrs: {
	      "options": _vm.staticData.windOptions
	    },
	    model: {
	      value: (_vm.userData.wind),
	      callback: function($$v) {
	        _vm.userData.wind = $$v
	      },
	      expression: "userData.wind"
	    }
	  })], 1)], 1)], 1)]), _vm._v(" "), _c('b-form-fieldset', [_c('legend', [_vm._v("Situational")]), _vm._v(" "), _vm._l((_vm.sortedSitMods), function(pair) {
	    return _c('b-form-checkbox', {
	      key: pair.key,
	      model: {
	        value: (_vm.userData.rangedSitMods[pair.key]),
	        callback: function($$v) {
	          _vm.$set(_vm.userData.rangedSitMods, pair.key, $$v)
	        },
	        expression: "userData.rangedSitMods[pair.key]"
	      }
	    }, [_vm._v("\n      " + _vm._s(pair.value) + "\n    ")])
	  }), _vm._v(" "), _c('b-form-radio-group', {
	    attrs: {
	      "options": _vm.staticData.rangedLOSOptions
	    },
	    model: {
	      value: (_vm.userData.rangedLOS),
	      callback: function($$v) {
	        _vm.userData.rangedLOS = $$v
	      },
	      expression: "userData.rangedLOS"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('setting-col', [_c('b-form-group', {
	    attrs: {
	      "label": "Distance to target",
	      "state": _vm.distanceValid,
	      "description": _vm.distanceDescription
	    }
	  }, [_c('b-input-group', {
	    attrs: {
	      "right": "m"
	    }
	  }, [_c('b-form-input', {
	    attrs: {
	      "type": "number",
	      "formatter": _vm.zeroOrGreater,
	      "state": _vm.distanceValid,
	      "lazy-formatter": ""
	    },
	    model: {
	      value: (_vm.userData.distance),
	      callback: function($$v) {
	        _vm.userData.distance = $$v
	      },
	      expression: "userData.distance"
	    }
	  })], 1), _vm._v(" "), (!_vm.distanceValid) ? _c('div', {
	    staticClass: "error-feedback"
	  }, [_vm._v("\n            Enter a valid distance.\n          ")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.weaponHasRecoil) ? _c('setting-col', [_c('b-form-group', {
	    attrs: {
	      "label": "Bullets fired",
	      "description": "Include current action. Cumulative across Action Phases until an non-shooting action is taken. Ignore when firing a single weapon in Single Shot mode."
	    }
	  }, [_c('b-form-input', {
	    attrs: {
	      "type": "number",
	      "formatter": _vm.zeroOrGreater,
	      "lazy-formatter": ""
	    },
	    model: {
	      value: (_vm.userData.bulletsFired),
	      callback: function($$v) {
	        _vm.userData.bulletsFired = $$v
	      },
	      expression: "userData.bulletsFired"
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.hasWirelessProjectileBonus) ? _c('setting-col', [_c('b-form-group', {
	    attrs: {
	      "label": "Wireless projectile bonus",
	      "description": "The number of wireless projectiles you've already thrown at your current target this Combat Turn (if your current projectile is also wireless)."
	    }
	  }, [_c('b-form-input', {
	    attrs: {
	      "type": "number",
	      "formatter": _vm.zeroOrGreater,
	      "lazy-formatter": ""
	    },
	    model: {
	      value: (_vm.userData.wirelessProjectileBonus),
	      callback: function($$v) {
	        _vm.userData.wirelessProjectileBonus = $$v
	      },
	      expression: "userData.wirelessProjectileBonus"
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('setting-col', [_c('b-form-group', {
	    attrs: {
	      "label": "Take Aim bonus",
	      "description": "Maximum WIL ÷ 2, rounded up."
	    }
	  }, [_c('b-form-input', {
	    attrs: {
	      "type": "number",
	      "formatter": _vm.takeAimBonusFormatter,
	      "lazy-formatter": ""
	    },
	    model: {
	      value: (_vm.userData.takeAimBonus),
	      callback: function($$v) {
	        _vm.userData.takeAimBonus = $$v
	      },
	      expression: "userData.takeAimBonus"
	    }
	  })], 1)], 1), _vm._v(" "), _c('setting-col', [_c('b-form-group', {
	    attrs: {
	      "label": "Other modifiers",
	      "description": "Use this for any modifiers not covered by other fields."
	    }
	  }, [_c('b-form-input', {
	    attrs: {
	      "type": "number"
	    },
	    model: {
	      value: (_vm.userData.otherModifiers),
	      callback: function($$v) {
	        _vm.userData.otherModifiers = $$v
	      },
	      expression: "userData.otherModifiers"
	    }
	  })], 1)], 1)], 1)], 2), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-6 offset-lg-3"
	  }, [(_vm.allInputValid) ? _c('b-card', {
	    staticClass: "text-center",
	    attrs: {
	      "bg-variant": "trans",
	      "border-variant": "primary"
	    }
	  }, [_c('h3', {
	    staticStyle: {
	      "display": "inline"
	    }
	  }, [_vm._v("Total dice pool: " + _vm._s(_vm.totalDicePoolString))])]) : _c('b-card', {
	    staticClass: "text-center",
	    attrs: {
	      "bg-variant": "trans",
	      "border-variant": "danger"
	    }
	  }, [_c('h3', {
	    staticStyle: {
	      "display": "inline"
	    }
	  }, [_vm._v("No attack possible!")])])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "row mt-2"
	  }, [_c('div', {
	    staticClass: "col-lg-6 offset-lg-3"
	  }, [_c('div', {
	    staticClass: "btn-group btn-group-justified",
	    attrs: {
	      "role": "group"
	    }
	  }, [_c('b-button-group', [_c('b-button', {
	    attrs: {
	      "variant": "outline-warning",
	      "size": "lg"
	    },
	    on: {
	      "click": _vm.clearSituational
	    }
	  }, [_vm._v("\n            Clear situational\n          ")])], 1), _vm._v(" "), _c('b-button-group', [_c('b-button', {
	    attrs: {
	      "variant": "outline-danger",
	      "size": "lg"
	    },
	    on: {
	      "click": _vm.clearUserData
	    }
	  }, [_vm._v("\n            Clear all\n          ")])], 1)], 1)])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('b-card', {
	    staticClass: "mb-2",
	    attrs: {
	      "header-tag": "header"
	    }
	  }, [_c('div', {
	    slot: "header"
	  }, [_c('div', {
	    staticClass: "float-right"
	  }, [(_vm.isHitsMode && !_vm.isAnimating && _vm.roll.edgeMode === _vm.EdgeMode.NONE) ? _c('b-btn', {
	    directives: [{
	      name: "b-tooltip",
	      rawName: "v-b-tooltip.html.window.hover",
	      modifiers: {
	        "html": true,
	        "window": true,
	        "hover": true
	      }
	    }],
	    attrs: {
	      "size": "sm",
	      "variant": "outline-warning",
	      "title": "<h6>Push the Limit</h6>Spend a point of Edge to roll dice equal to your Edge, re-rolling any new sixes for extra hits, and ignore the limit."
	    },
	    on: {
	      "click": function($event) {
	        _vm.$emit('usedPushTheLimit', _vm.roll.id)
	      }
	    }
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "chevron-double-up",
	      "fixed-width": ""
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.isHitsMode && !_vm.isAnimating && _vm.roll.edgeMode === _vm.EdgeMode.NONE) ? _c('b-btn', {
	    directives: [{
	      name: "b-tooltip",
	      rawName: "v-b-tooltip.html.window.hover",
	      modifiers: {
	        "html": true,
	        "window": true,
	        "hover": true
	      }
	    }],
	    attrs: {
	      "size": "sm",
	      "variant": "outline-warning",
	      "title": "<h6>Second Chance</h6>Spend a point of Edge to re-roll dice that didn't score a hit; doesn't negate glitches."
	    },
	    on: {
	      "click": function($event) {
	        _vm.$emit('usedSecondChance', _vm.roll.id)
	      }
	    }
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "redo",
	      "fixed-width": ""
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.isHitsMode && !_vm.isAnimating && _vm.roll.edgeMode === _vm.EdgeMode.NONE && _vm.glitchLevel > 0) ? _c('b-btn', {
	    directives: [{
	      name: "b-tooltip",
	      rawName: "v-b-tooltip.html.window.hover",
	      modifiers: {
	        "html": true,
	        "window": true,
	        "hover": true
	      }
	    }],
	    attrs: {
	      "size": "sm",
	      "variant": "outline-warning",
	      "title": "<h6>Close Call</h6>Negate the effects of a glitch, or turn a critical glitch into a regular glitch."
	    },
	    on: {
	      "click": function($event) {
	        _vm.$emit('usedCloseCall', _vm.roll.id)
	      }
	    }
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "tint",
	      "fixed-width": ""
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('b-btn', {
	    directives: [{
	      name: "b-tooltip",
	      rawName: "v-b-tooltip.window.hover",
	      modifiers: {
	        "window": true,
	        "hover": true
	      }
	    }],
	    attrs: {
	      "size": "sm",
	      "variant": "danger",
	      "title": "Delete this roll"
	    },
	    on: {
	      "click": function($event) {
	        _vm.$emit('deletedRoll', _vm.roll.id)
	      }
	    }
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "times",
	      "fixed-width": ""
	    }
	  })], 1)], 1), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "b-tooltip",
	      rawName: "v-b-tooltip.window.hover.left",
	      modifiers: {
	        "window": true,
	        "hover": true,
	        "left": true
	      }
	    }],
	    staticClass: "roll-label pt-1",
	    attrs: {
	      "title": _vm.date
	    },
	    on: {
	      "mouseenter": function($event) {
	        _vm.showEditIcon = true
	      },
	      "mouseleave": function($event) {
	        _vm.showEditIcon = false
	      },
	      "click": _vm.startEditLabel
	    }
	  }, [(_vm.isEditingLabel) ? _c('span', {
	    staticClass: "float-left"
	  }, [_c('b-form-input', {
	    ref: "labelInput",
	    nativeOn: {
	      "blur": function($event) {
	        _vm.endEditLabel($event)
	      },
	      "keyup": function($event) {
	        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
	        _vm.endEditLabel($event)
	      }
	    },
	    model: {
	      value: (_vm.roll.label),
	      callback: function($$v) {
	        _vm.roll.label = $$v
	      },
	      expression: "roll.label"
	    }
	  })], 1) : _c('span', [_vm._v("\n        " + _vm._s(_vm.roll.label) + "\n        "), (_vm.showEditIcon) ? _c('span', {
	    staticClass: "text-muted"
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "pen",
	      "transform": "shrink-3 up-2"
	    }
	  })], 1) : _vm._e()])])]), _vm._v(" "), _c('b-row', [_c('b-col', {
	    staticClass: "pr-md-2",
	    attrs: {
	      "md": "7"
	    }
	  }, [_c('h1', [(_vm.isAnimating) ? _c('b-badge', {
	    staticClass: "align-top text-uppercase",
	    attrs: {
	      "variant": "info"
	    }
	  }, [_vm._v("\n          ROLLING...\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isAnimating && !_vm.isHitsMode) ? _c('b-badge', {
	    staticClass: "align-top text-uppercase",
	    attrs: {
	      "variant": "success"
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.sum) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isAnimating && _vm.isHitsMode && (_vm.totalHits > 0 || _vm.glitchLevel === 0)) ? _c('b-badge', {
	    staticClass: "align-top text-uppercase",
	    attrs: {
	      "variant": "success"
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm.limitedHits) + " " + _vm._s(_vm._f("pluralize")(_vm.limitedHits, 'hit')) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isAnimating && _vm.isHitsMode && _vm.glitchLevel === 1) ? _c('b-badge', {
	    staticClass: "align-top text-uppercase",
	    attrs: {
	      "variant": "danger"
	    }
	  }, [_vm._v("\n          GLITCH\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isAnimating && _vm.isHitsMode && _vm.glitchLevel === 2) ? _c('b-badge', {
	    staticClass: "align-top text-uppercase",
	    attrs: {
	      "variant": "danger"
	    }
	  }, [_vm._v("\n          CRITICAL GLITCH\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('span', {
	    staticClass: "dice"
	  }, _vm._l((_vm.roll.dice), function(group, groupIndex) {
	    return (!_vm.animate || groupIndex <= _vm.revealedGroup) ? _c('div', {
	      key: groupIndex,
	      staticClass: "dice-group"
	    }, [(groupIndex > 0) ? _c('span', {
	      staticClass: "die-plus"
	    }, [_c('font-awesome-icon', {
	      attrs: {
	        "icon": ['far', 'plus']
	      }
	    })], 1) : _vm._e(), _vm._l((group), function(value, dieIndex) {
	      return _c('die', {
	        key: dieIndex,
	        attrs: {
	          "frame-length": _vm.dieFrameLength,
	          "no-highlight": !_vm.isHitsMode,
	          "highlight-one": !(_vm.roll.edgeMode == _vm.EdgeMode.SECOND_CHANCE && groupIndex == 0),
	          "highlight-six": _vm.roll.edgeMode == _vm.EdgeMode.PUSH_LIMIT_PRE || _vm.roll.edgeMode == _vm.EdgeMode.PUSH_LIMIT_POST && groupIndex > 0,
	          "rolling": _vm.animate && !(groupIndex < _vm.revealedGroup || (dieIndex < _vm.revealedDie && groupIndex <= _vm.revealedGroup)),
	          "value": value
	        },
	        on: {
	          "onFrame": _vm.revealDie
	        }
	      })
	    })], 2) : _vm._e()
	  }))]), _vm._v(" "), _c('b-col', {
	    staticClass: "pl-md-0",
	    attrs: {
	      "md": "5"
	    }
	  }, [_c('div', {
	    staticClass: "roll-sidebar"
	  }, [_c('span', {
	    staticClass: "font-weight-bold"
	  }, [_vm._v("Roll:")]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "b-tooltip",
	      rawName: "v-b-tooltip.hover",
	      value: ('Dice pool: ' + _vm.roll.dicePool + (_vm.roll.edgeMode === _vm.EdgeMode.PUSH_LIMIT_PRE ? ' + ' + _vm.roll.edge + ' from Push the Limit' : '')),
	      expression: "'Dice pool: ' + roll.dicePool + (roll.edgeMode === EdgeMode.PUSH_LIMIT_PRE ? ' + ' + roll.edge + ' from Push the Limit' : '')",
	      modifiers: {
	        "hover": true
	      }
	    }]
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "clone",
	      "fixed-width": ""
	    }
	  }), _vm._v("\n          " + _vm._s(_vm.roll.dicePool) + "\n          "), (_vm.roll.edgeMode === _vm.EdgeMode.PUSH_LIMIT_PRE) ? _c('span', {
	    staticClass: "text-warning"
	  }, [_vm._v("\n            + " + _vm._s(_vm.roll.edge) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), (_vm.isHitsMode) ? _c('span', {
	    directives: [{
	      name: "b-tooltip",
	      rawName: "v-b-tooltip.hover",
	      value: ('Limit: ' + (_vm.roll.limit === null ? 'None' : _vm.roll.limit) + (_vm.roll.limit ? ' (ignored)' : '')),
	      expression: "'Limit: ' + (roll.limit === null ? 'None' : roll.limit) + (roll.limit ? ' (ignored)' : '')",
	      modifiers: {
	        "hover": true
	      }
	    }]
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "arrow-to-top",
	      "fixed-width": ""
	    }
	  }), _vm._v("\n          " + _vm._s((_vm.roll.limit === null || _vm.usedPushTheLimit) ? 'N/A' : _vm.roll.limit) + "\n        ")], 1) : _vm._e(), _vm._v(" "), (_vm.isSumMode) ? _c('span', {
	    directives: [{
	      name: "b-tooltip",
	      rawName: "v-b-tooltip.hover",
	      value: ('Base value: ' + _vm.roll.baseValue),
	      expression: "'Base value: ' + roll.baseValue",
	      modifiers: {
	        "hover": true
	      }
	    }]
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "arrow-to-bottom",
	      "fixed-width": ""
	    }
	  }), _vm._v("\n          " + _vm._s(_vm.roll.baseValue) + "\n        ")], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.isAnimating) ? _c('span', [_c('span', {
	    staticClass: "font-weight-bold"
	  }, [_vm._v("Result:")]), _vm._v(" "), (_vm.isHitsMode) ? _c('span', [_c('span', {
	    directives: [{
	      name: "b-tooltip",
	      rawName: "v-b-tooltip.hover",
	      value: (_vm.getHitString(_vm.baseHits, _vm.roll.limit, _vm.roll.limit === null)),
	      expression: "getHitString(baseHits, roll.limit, roll.limit === null)",
	      modifiers: {
	        "hover": true
	      }
	    }],
	    staticClass: "text-success"
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "crosshairs",
	      "fixed-width": ""
	    }
	  }), _vm._v("\n              " + _vm._s((_vm.roll.limit !== null && _vm.baseHits > _vm.roll.limit) ? _vm.roll.limit + ' (' + _vm.baseHits + ')' : _vm.baseHits) + "\n            ")], 1), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "b-tooltip",
	      rawName: "v-b-tooltip.hover",
	      value: (_vm.getMissString(_vm.baseMisses)),
	      expression: "getMissString(baseMisses)",
	      modifiers: {
	        "hover": true
	      }
	    }],
	    staticClass: "text-danger"
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "ban",
	      "fixed-width": ""
	    }
	  }), _vm._v("\n              " + _vm._s(_vm.baseMisses) + "\n            ")], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.roll.edgeMode !== _vm.EdgeMode.NONE) ? _c('span', [_c('span', {
	    staticClass: "font-weight-bold"
	  }, [_vm._v("Edge:")]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "b-tooltip",
	      rawName: "v-b-tooltip.hover",
	      value: (_vm.edgeModeString),
	      expression: "edgeModeString",
	      modifiers: {
	        "hover": true
	      }
	    }]
	  }, [(_vm.usedPushTheLimit) ? _c('span', [_c('span', {
	    staticClass: "text-warning"
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "chevron-double-up",
	      "fixed-width": ""
	    }
	  }), _vm._v("\n                    " + _vm._s(_vm.roll.edge) + "\n                  ")], 1), _vm._v(" "), _c('font-awesome-icon', {
	    attrs: {
	      "icon": ['far', 'arrow-right'],
	      "fixed-width": ""
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "text-warning"
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "bomb",
	      "fixed-width": ""
	    }
	  }), _vm._v("\n                    " + _vm._s(_vm.rerollDicePool) + "\n                  ")], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.roll.edgeMode === _vm.EdgeMode.SECOND_CHANCE) ? _c('span', [_c('span', {
	    staticClass: "text-warning"
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "redo",
	      "fixed-width": ""
	    }
	  }), _vm._v("\n                    " + _vm._s(_vm.rerollDicePool) + "\n                  ")], 1), _vm._v(" "), (_vm.baseMisses > 0) ? _c('span', [_c('font-awesome-icon', {
	    attrs: {
	      "icon": ['far', 'arrow-right'],
	      "fixed-width": ""
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "text-warning"
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "ban",
	      "fixed-width": ""
	    }
	  }), _vm._v("\n                      -" + _vm._s(_vm.baseMisses) + "\n                    ")], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.roll.edgeMode === _vm.EdgeMode.CLOSE_CALL) ? _c('span', [_c('span', {
	    staticClass: "text-warning"
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "tint",
	      "fixed-width": ""
	    }
	  })], 1), _vm._v(" "), (_vm.baseMisses > 0) ? _c('span', [_c('font-awesome-icon', {
	    attrs: {
	      "icon": ['far', 'arrow-right'],
	      "fixed-width": ""
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "text-warning"
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "exclamation-triangle"
	    }
	  }), _vm._v(" "), _c('font-awesome-icon', {
	    attrs: {
	      "icon": "level-down"
	    }
	  })], 1)], 1) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.rollModified) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.rollModified) ? _c('span', [_c('span', {
	    staticClass: "font-weight-bold"
	  }, [_vm._v("Final:")]), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "b-tooltip",
	      rawName: "v-b-tooltip.hover",
	      value: (_vm.getHitString(_vm.totalHits, _vm.roll.limit, _vm.usedPushTheLimit || _vm.roll.limit === null)),
	      expression: "getHitString(totalHits, roll.limit, usedPushTheLimit || roll.limit === null)",
	      modifiers: {
	        "hover": true
	      }
	    }],
	    staticClass: "text-success"
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "crosshairs",
	      "fixed-width": ""
	    }
	  }), _vm._v("\n                " + _vm._s((_vm.roll.limit !== null && _vm.totalHits > _vm.roll.limit && !_vm.usedPushTheLimit) ? _vm.roll.limit + ' (' + _vm.totalHits + ')' : _vm.totalHits) + "\n              ")], 1), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "b-tooltip",
	      rawName: "v-b-tooltip.hover",
	      value: (_vm.getMissString(_vm.totalMisses)),
	      expression: "getMissString(totalMisses)",
	      modifiers: {
	        "hover": true
	      }
	    }],
	    staticClass: "text-danger"
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "ban",
	      "fixed-width": ""
	    }
	  }), _vm._v("\n                " + _vm._s(_vm.totalMisses) + "\n              ")], 1)]) : _vm._e()]) : _c('span', [_vm._v("\n            " + _vm._s(_vm.sum - _vm.roll.baseValue) + " + " + _vm._s(_vm.roll.baseValue) + " = "), _c('span', {
	    staticClass: "font-weight-bold"
	  }, [_vm._v(_vm._s(_vm.sum))])])]) : _c('span', [_c('span', [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "spinner",
	      "pulse": ""
	    }
	  }), _vm._v(" Rolling...")], 1)])])])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: _vm.className
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('b-navbar', {
	    attrs: {
	      "type": "dark",
	      "variant": "primary",
	      "toggle-breakpoint": "md",
	      "toggleable": ""
	    }
	  }, [_c('b-nav-toggle', {
	    attrs: {
	      "target": "navbarSupportedContent",
	      "aria-controls": "navbarSupportedContent",
	      "aria-expanded": "false",
	      "aria-label": "Toggle navigation"
	    }
	  }), _vm._v(" "), _c('b-navbar-brand', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_vm._v("Shadowtools")]), _vm._v(" "), _c('b-collapse', {
	    attrs: {
	      "is-nav": "",
	      "id": "navbarSupportedContent"
	    }
	  }, [_c('b-navbar-nav', {
	    staticClass: "mr-auto"
	  }, [_c('b-nav-item', {
	    attrs: {
	      "to": "/modifiers"
	    }
	  }, [_vm._v("Dice Pool Modifiers")]), _vm._v(" "), _c('b-nav-item', {
	    attrs: {
	      "to": "/roller"
	    }
	  }, [_vm._v("Dice Roller")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "container",
	    attrs: {
	      "id": "container"
	    }
	  }, [_c('router-view')], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "roller"
	  }, [_c('b-modal', {
	    attrs: {
	      "id": "pushLimitModal",
	      "title": "Push the Limit!"
	    },
	    on: {
	      "ok": _vm.pushLimitOk
	    }
	  }, [_c('b-form-group', {
	    attrs: {
	      "label": "Enter your Edge attribute:"
	    }
	  }, [_c('b-form-input', {
	    attrs: {
	      "type": "number",
	      "formatter": _vm.zeroOrGreater,
	      "lazy-formatter": ""
	    },
	    model: {
	      value: (_vm.userData.edge),
	      callback: function($$v) {
	        _vm.userData.edge = $$v
	      },
	      expression: "userData.edge"
	    }
	  })], 1)], 1), _vm._v(" "), _c('b-modal', {
	    attrs: {
	      "id": "clearRollHistoryModal",
	      "ok-title": "Yes",
	      "hide-header": true
	    },
	    on: {
	      "ok": _vm.clearRollHistory
	    }
	  }, [_c('h5', [_c('span', {
	    staticClass: "text-warning mr-2"
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "exclamation-triangle"
	    }
	  })], 1), _vm._v("\n      Are you sure you want to delete your entire roll history?\n    ")])]), _vm._v(" "), _c('b-row', [_c('b-col', {
	    attrs: {
	      "lg": "4"
	    }
	  }, [_c('b-card', {
	    staticClass: "mb-2 roller-settings",
	    attrs: {
	      "no-body": "",
	      "border-variant": "primary"
	    }
	  }, [_c('b-tabs', {
	    attrs: {
	      "card": ""
	    }
	  }, [_c('b-tab', {
	    attrs: {
	      "title": "Roll",
	      "active": ""
	    }
	  }, [_c('b-form-group', {
	    staticClass: "mb-0"
	  }, [_c('b-row', [_c('b-col', {
	    attrs: {
	      "cols": "12"
	    }
	  }, [_c('b-form-group', {
	    attrs: {
	      "label": "Label",
	      "description": "Optional! Use this to remember why you rolled."
	    }
	  }, [_c('div', {
	    staticClass: "d-flex"
	  }, [_c('b-input-group', {
	    staticStyle: {
	      "margin-right": "-1px"
	    }
	  }, [_c('b-input-group-button', [_c('b-dropdown', [_c('b-dropdown-header', [_vm._v("Hit presets" + _vm._s(_vm.hitsPresets.length === 0 ? ' (none saved yet!)' : ''))]), _vm._v(" "), _vm._l((_vm.hitsPresets), function(preset) {
	    return _c('b-dropdown-item', {
	      key: preset.label,
	      on: {
	        "click": function($event) {
	          _vm.loadPreset(preset)
	        }
	      }
	    }, [_vm._v("\n                              " + _vm._s(preset.label) + "\n                              "), _c('span', {
	      staticClass: "text-muted"
	    }, [_vm._v("\n                                —\n                                "), _c('font-awesome-icon', {
	      attrs: {
	        "icon": "clone",
	        "fixed-width": ""
	      }
	    }), _vm._v(" " + _vm._s(preset.dicePool) + "\n                                "), _c('font-awesome-icon', {
	      attrs: {
	        "icon": "arrow-to-top",
	        "fixed-width": ""
	      }
	    }), _vm._v(" " + _vm._s(preset.useLimit ? preset.limit : 'N/A') + "\n                              ")], 1)])
	  }), _vm._v(" "), _c('b-dropdown-divider'), _vm._v(" "), _c('b-dropdown-header', [_vm._v("Sum presets" + _vm._s(_vm.sumPresets.length === 0 ? ' (none saved yet!)' : ''))]), _vm._v(" "), _vm._l((_vm.sumPresets), function(preset) {
	    return _c('b-dropdown-item', {
	      key: preset.label,
	      on: {
	        "click": function($event) {
	          _vm.loadPreset(preset)
	        }
	      }
	    }, [_vm._v("\n                              " + _vm._s(preset.label) + "\n                              "), _c('span', {
	      staticClass: "text-muted"
	    }, [_vm._v("\n                                —\n                                " + _vm._s(preset.baseValue) + " + " + _vm._s(preset.dicePool) + "d6\n                              ")])])
	  })], 2)], 1), _vm._v(" "), _c('b-form-input', {
	    model: {
	      value: (_vm.userData.rollSettings.label),
	      callback: function($$v) {
	        _vm.userData.rollSettings.label = $$v
	      },
	      expression: "userData.rollSettings.label"
	    }
	  })], 1), _vm._v(" "), _c('b-button', {
	    directives: [{
	      name: "b-tooltip",
	      rawName: "v-b-tooltip.window.hover",
	      modifiers: {
	        "window": true,
	        "hover": true
	      }
	    }],
	    staticClass: "ml-1",
	    attrs: {
	      "title": "Save preset",
	      "variant": "success"
	    },
	    on: {
	      "click": _vm.savePreset
	    }
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "save",
	      "fixed-width": ""
	    }
	  })], 1), _vm._v(" "), _c('b-button', {
	    directives: [{
	      name: "b-tooltip",
	      rawName: "v-b-tooltip.window.hover",
	      modifiers: {
	        "window": true,
	        "hover": true
	      }
	    }],
	    staticClass: "ml-1",
	    attrs: {
	      "title": "Delete preset",
	      "variant": "danger"
	    },
	    on: {
	      "click": _vm.deletePreset
	    }
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "trash",
	      "fixed-width": ""
	    }
	  })], 1)], 1)])], 1), _vm._v(" "), _c('b-col', {
	    attrs: {
	      "cols": "12"
	    }
	  }, [_c('b-form-group', {
	    attrs: {
	      "label": "Mode"
	    }
	  }, [_c('div', {
	    staticClass: "text-center"
	  }, [_c('b-form-radio-group', {
	    attrs: {
	      "buttons": "",
	      "button-variant": "outline-primary text-white",
	      "name": "radiosBtnDefault"
	    },
	    model: {
	      value: (_vm.userData.rollSettings.mode),
	      callback: function($$v) {
	        _vm.userData.rollSettings.mode = $$v
	      },
	      expression: "userData.rollSettings.mode"
	    }
	  }, [_c('b-form-radio', {
	    directives: [{
	      name: "b-tooltip",
	      rawName: "v-b-tooltip.window.hover",
	      modifiers: {
	        "window": true,
	        "hover": true
	      }
	    }],
	    attrs: {
	      "value": "hits",
	      "title": "Count hits and misses. Use this for most tests."
	    }
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "crosshairs",
	      "fixed-width": ""
	    }
	  }), _vm._v(" Hits\n                        ")], 1), _vm._v(" "), _c('b-form-radio', {
	    directives: [{
	      name: "b-tooltip",
	      rawName: "v-b-tooltip.window.hover",
	      modifiers: {
	        "window": true,
	        "hover": true
	      }
	    }],
	    attrs: {
	      "value": "sum",
	      "title": "Count the total roll. Use this for e.g. initiative."
	    }
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "plus",
	      "fixed-width": ""
	    }
	  }), _vm._v(" Sum\n                        ")], 1)], 1)], 1)])], 1), _vm._v(" "), _c('b-col', {
	    attrs: {
	      "md": "6"
	    }
	  }, [_c('b-form-group', [_c('span', {
	    slot: "label"
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "clone",
	      "fixed-width": ""
	    }
	  }), _vm._v(" Dice pool\n                    ")], 1), _vm._v(" "), _c('b-form-input', {
	    attrs: {
	      "type": "number",
	      "formatter": _vm.zeroOrGreater,
	      "lazy-formatter": ""
	    },
	    model: {
	      value: (_vm.userData.rollSettings.dicePool),
	      callback: function($$v) {
	        _vm.userData.rollSettings.dicePool = $$v
	      },
	      expression: "userData.rollSettings.dicePool"
	    }
	  })], 1)], 1), _vm._v(" "), _c('b-col', {
	    attrs: {
	      "md": "6"
	    }
	  }, [(_vm.userData.rollSettings.mode === 'hits') ? _c('b-form-group', [_c('span', {
	    slot: "label"
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "arrow-to-top",
	      "fixed-width": ""
	    }
	  }), _vm._v(" Limit\n                      ")], 1), _vm._v(" "), _c('b-input-group', [_c('b-input-group-addon', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.userData.rollSettings.useLimit),
	      expression: "userData.rollSettings.useLimit"
	    }, {
	      name: "b-tooltip",
	      rawName: "v-b-tooltip.window.hover",
	      modifiers: {
	        "window": true,
	        "hover": true
	      }
	    }],
	    attrs: {
	      "type": "checkbox",
	      "title": "Uncheck to ignore limit."
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.userData.rollSettings.useLimit) ? _vm._i(_vm.userData.rollSettings.useLimit, null) > -1 : (_vm.userData.rollSettings.useLimit)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.userData.rollSettings.useLimit,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.userData.rollSettings.useLimit = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.userData.rollSettings.useLimit = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.userData.rollSettings.useLimit = $$c
	        }
	      }
	    }
	  })]), _vm._v(" "), _c('b-form-input', {
	    attrs: {
	      "type": "number",
	      "formatter": _vm.zeroOrGreater,
	      "disabled": !_vm.userData.rollSettings.useLimit,
	      "lazy-formatter": ""
	    },
	    model: {
	      value: (_vm.userData.rollSettings.limit),
	      callback: function($$v) {
	        _vm.userData.rollSettings.limit = $$v
	      },
	      expression: "userData.rollSettings.limit"
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.userData.rollSettings.mode === 'sum') ? _c('b-form-group', [_c('span', {
	    slot: "label"
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "arrow-to-bottom",
	      "fixed-width": ""
	    }
	  }), _vm._v(" Base value\n                    ")], 1), _vm._v(" "), _c('b-form-input', {
	    attrs: {
	      "type": "number",
	      "formatter": _vm.zeroOrGreater,
	      "lazy-formatter": ""
	    },
	    model: {
	      value: (_vm.userData.rollSettings.baseValue),
	      callback: function($$v) {
	        _vm.userData.rollSettings.baseValue = $$v
	      },
	      expression: "userData.rollSettings.baseValue"
	    }
	  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "text-center"
	  }, [_c('b-btn', {
	    staticClass: "mr-1",
	    attrs: {
	      "variant": "primary",
	      "size": "lg",
	      "id": "rollDiceButton"
	    },
	    on: {
	      "click": function($event) {
	        _vm.createRoll(false)
	      }
	    }
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "sync",
	      "fixed-width": ""
	    }
	  })], 1), _vm._v(" "), (_vm.userData.rollSettings.mode === 'hits') ? _c('b-btn', {
	    attrs: {
	      "variant": "outline-warning",
	      "size": "lg",
	      "id": "pushLimitButton"
	    },
	    on: {
	      "click": function($event) {
	        _vm.pushLimit(null)
	      }
	    }
	  }, [_c('font-awesome-icon', {
	    attrs: {
	      "icon": "chevron-double-up",
	      "fixed-width": ""
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('b-tooltip', {
	    ref: "rollDiceTooltip",
	    attrs: {
	      "target": "rollDiceButton",
	      "triggers": "hover"
	    }
	  }, [_vm._v("\n                  Roll the dice!\n                ")]), _vm._v(" "), (_vm.userData.rollSettings.mode === 'hits') ? _c('b-tooltip', {
	    ref: "pushLimitTooltip",
	    attrs: {
	      "target": "pushLimitButton",
	      "triggers": "hover"
	    }
	  }, [_c('h6', [_vm._v("Push the Limit")]), _vm._v("\n                  Spend a point of Edge to add your Edge rating to the dice pool, reroll sixes for extra hits, and ignore the limit.\n                ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-tab', {
	    attrs: {
	      "title": "Settings"
	    }
	  }, [_c('b-form-checkbox', {
	    model: {
	      value: (_vm.userData.animateDice),
	      callback: function($$v) {
	        _vm.userData.animateDice = $$v
	      },
	      expression: "userData.animateDice"
	    }
	  }, [_vm._v("\n              Animate dice\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "text-center"
	  }, [_c('b-btn', {
	    directives: [{
	      name: "b-modal",
	      rawName: "v-b-modal.clearRollHistoryModal",
	      modifiers: {
	        "clearRollHistoryModal": true
	      }
	    }],
	    attrs: {
	      "variant": "outline-danger",
	      "size": "lg"
	    }
	  }, [_vm._v("\n                Clear roll history\n              ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
	    attrs: {
	      "lg": "8"
	    }
	  }, _vm._l((_vm.reversedHistory), function(roll) {
	    return _c('roll-info', {
	      key: roll.id,
	      attrs: {
	        "roll": roll,
	        "animate": _vm.rollsToAnimate.indexOf(roll.id) !== -1 && _vm.userData.animateDice
	      },
	      on: {
	        "deletedRoll": _vm.deleteRoll,
	        "usedPushTheLimit": _vm.pushLimit,
	        "usedSecondChance": _vm.secondChance,
	        "usedCloseCall": _vm.closeCall
	      }
	    })
	  }))], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('svg', {
	    class: _vm.svgName
	  }, [_c('use', {
	    attrs: {
	      "xlink:href": _vm.xlinkName
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tracker"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-6"
	  }, [_c('b-card', {
	    attrs: {
	      "no-block": "",
	      "variant": "outline-primary",
	      "header": "Current Initiative Pass",
	      "inverse": false
	    }
	  }, [_c('b-table', {
	    staticClass: "card-table",
	    attrs: {
	      "striped": "",
	      "hover": "",
	      "items": _vm.ipTableItems,
	      "fields": _vm.ipTableFields
	    },
	    scopedSlots: _vm._u([{
	      key: "name",
	      fn: function(data) {
	        return [_c('span', {
	          class: {
	            'text-completed': data.item.completed
	          }
	        }, [_vm._v("\n              " + _vm._s(data.value) + "\n            ")])]
	      }
	    }, {
	      key: "initiative",
	      fn: function(data) {
	        return [_c('span', {
	          class: {
	            'text-completed': data.item.completed
	          }
	        }, [_vm._v("\n              " + _vm._s(data.value) + "\n            ")])]
	      }
	    }])
	  })], 1), _vm._v(" "), _c('b-card', {
	    staticClass: "mt-4",
	    attrs: {
	      "no-block": "",
	      "variant": "outline-secondary",
	      "header": "Upcoming"
	    }
	  }, [_c('b-table', {
	    staticClass: "card-table",
	    attrs: {
	      "striped": "",
	      "items": _vm.upcomingItems,
	      "fields": _vm.upcomingFields
	    },
	    scopedSlots: _vm._u([{
	      key: "name",
	      fn: function(data) {
	        return [_vm._v(_vm._s(data.value))]
	      }
	    }, {
	      key: "initiative",
	      fn: function(data) {
	        return [_vm._v(_vm._s(data.value))]
	      }
	    }, {
	      key: "combatTurn",
	      fn: function(data) {
	        return [_vm._v(_vm._s(data.value))]
	      }
	    }])
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-6"
	  }, [_c('h2', [_vm._v("It's Six's turn.")]), _vm._v(" "), _c('p', [_vm._v("\n        Current combat turn: " + _vm._s(_vm.combatTurn) + " "), _c('br'), _vm._v("\n        Current initiative: " + _vm._s(_vm.initiative) + "\n      ")])])])])
	},staticRenderFns: []}

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.051a97ada024ab9f5988.js